import { render, staticRenderFns } from "./FooterServicePrivacyOld.vue?vue&type=template&id=0b16fdf6&scoped=true&"
import script from "./FooterServicePrivacyOld.vue?vue&type=script&lang=ts&"
export * from "./FooterServicePrivacyOld.vue?vue&type=script&lang=ts&"
import style0 from "./FooterServicePrivacyOld.vue?vue&type=style&index=0&id=0b16fdf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16fdf6",
  null
  
)

export default component.exports